import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import usePagination from './usePagination';
import { getClinics } from 'services/clinics';

const id = 'clinics';

export const useClinics = (search = '') => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const handlerFetchData = async ({ queryKey }) => {
        const [, { search }] = queryKey;

        return getClinics(
            paginationModel.pageSize,
            currentToken(paginationModel.page),
            search
        );
    };

    const { isPending, isError, data } = useQuery({
        queryKey: [
            id,
            {
                search,
                paginationModel
            }
        ],
        queryFn: handlerFetchData,
        keepPreviousData: true
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};
